import { component_tool, framework_tool, utils_tool } from '@/tool';
import React from 'react';

let { WizModal } = component_tool;
let ref
//配置项
let componentName = 'thirdApp'

const columns = (info) => {
  const { corpList, corpInfoId } = info
  return [
    {
      name: "id",
      formItem: {
        type: "hidden"
      }
    },
    {
      title: "名称",
      name: "name",
      dataIndex: "name",
      searchItem: {},
      formItem: {
        rules: [{
          required: true,
          message: '请输入名称',
        }],
        maxlength: 30,
        placeholder: "名称不能超过30个字。"
      },
      tableItem: {}
    },
    {
      title: "所属企业",
      name: "corpInfoId",
      dataIndex: "corpInfoId",
      formItem: {
        type: "select",
        rules: [{
          required: true,
          message: '请选择所属企业',
        }]
      },
      dict: corpList || [],
      searchItem: {
        type: "select",
        initialValue: corpInfoId || null,

        rules: [{
          required: true,
          message: '请选择所属企业',
        }]
      },
    },
    {
      title: "所属企业",
      name: "corpInfoName",
      dataIndex: "corpInfoName",
      tableItem: {}
    },
    {
      title: "应用id",
      name: "appId",
      dataIndex: "appId",
      formItem: {
      },
      tableItem: {}
    },
    {
      title: "密钥",
      name: "secretId",
      dataIndex: "secretId",
      formItem: {
        
        rules: [{
          required: true,
          message: '请选择所属企业',
        }],
        maxlength: 128,
        placeholder: "密钥不能超过128个字。"
      },
      tableItem: {}
    },
    {
      title: "备注",
      name: "remark",
      dataIndex: "remark",
      formItem: {
        maxlength: 100,
        placeholder: "备注不能超过100个字。"
      },
      tableItem: {}
    },
    {
      title: "应用标识",
      name: "appFlag",
      dataIndex: "appFlag",
      formItem: {
        maxlength: 100,
        placeholder: "应用code不能超过100个字。"
      },
      tableItem: {}
    },
    {
      title: "AIDM提供client_id",
      name: "clientId",
      dataIndex: "clientId",
      formItem: {
        maxlength: 100,
        placeholder: "应用code不能超过100个字。"
      },
      tableItem: {}
    },
    {
      title: "AIDM提供client_secret",
      name: "clientSecret",
      dataIndex: "clientSecret",
      formItem: {
        maxlength: 512,
        placeholder: "应用code不能超过512个字。"
      },
      tableItem: {}
    },
    //   {
    //     title: "访问令牌",
    //     name: "accessToken",
    //     dataIndex: "accessToken",
    //     formItem: {},
    //     tableItem: {}
    //   },
  ]
};

const templateConfig = (coprList) => {
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns(coprList),
        searchBarProps: {
          cols: {
            xs: 24,
            md: 12,
            xl: 12
          },
          buttonSort: ['add', 'delete'],

        },
        modalFormProps: {
          modalOpts: {
            width: 950,
          },
        },
        dataTableProps: {
          rowKey: "id",
          selectType: "checkbox",
          isScroll: true,
          loading: false
        },
        rowOperateSort: ['update','authSetting'],
        rowOperateView: [
          {
            key: "authSetting",
            custom: true,
            params: { children: "受众设置" },
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/auth/corpManager/appAuthSetting",
              },
            },
          },
        ],
        commonOperate: {
          add: true,
          delete: true,
          update: true
        }
      }
    }
  }
};

const apis = (data) => {
  let { corpInfoId } = data || {}
  return {
    list: {
      path: `${componentName}/listByPage`,
      payload: {
        key: `${componentName}@listByPage`,
        apiParams: { pageNum: 1, pageSize: 10, corpInfoId: corpInfoId }
      }
    },
    add: {
      path: `${componentName}/add`,
      payload: {
        key: `${componentName}@add`,
      }
    },
    delete: {
      path: `${componentName}/delete`,
      payload: {
        key: `${componentName}@delete`,
      }
    },
    update: {
      path: `${componentName}/update`,
      payload: {
        key: `${componentName}@update`,
      }
    },
  }
}


let reduxTemplateCofig = (args) => {
  let { corpInfoId } = args

  return {
    apis: apis({ corpInfoId }),
    componentName,
    initApiKeys: ['list'],
    needLoading: false,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig };
